import { UserRole } from '@cpd-app/shared-module/constants';

/**
 * Reproduces what adminLogInSuccess writes, for the session-restore path.
 * `auth.isAuthenticated` is the admin-portal authentication flag (distinct from
 * cognitoAuth.isAuthenticated): historically only the admin login set it, so
 * learners never had it true. We keep that contract — only a counselor/admin
 * session restores role + isAuthenticated; learner/anonymous sessions stay
 * role: null, isAuthenticated: false exactly as before.
 */
export function deriveRestoredAuthorization(
  role: string,
  sessionIsAuthenticated: boolean
): { role: string; isAuthenticated: boolean } {
  const isCounselorOrAdmin =
    role === UserRole.Councelor ||
    role === UserRole.CouncelorAdmin ||
    role === UserRole.SuperAdmin;

  return {
    role: isCounselorOrAdmin ? role : null,
    isAuthenticated: !!sessionIsAuthenticated && isCounselorOrAdmin
  };
}
